export let LoadingKey;
(function (LoadingKey) {
  LoadingKey["InitiateVerificationRequest"] = "InitiateVerificationRequest";
  LoadingKey["CompleteVerificationRequest"] = "CompleteVerificationRequest";
  LoadingKey["SignupRequest"] = "SignupRequest";
  LoadingKey["StandardLoading"] = "StandardLoading";
  LoadingKey["BlankScreenLoading"] = "BlankScreenLoading";
  LoadingKey["LoginAfterSignup"] = "LoginAfterSignup";
  LoadingKey["PartnerExistingAccount"] = "PartnerExistingAccount";
  LoadingKey["PostSignupLoading"] = "PostSignupLoading";
  LoadingKey["GoogleContactsSyncLoading"] = "GoogleContactsSyncLoading";
  LoadingKey["ACQ142SignupRequest"] = "ACQ142SignupRequest";
  LoadingKey["ACQ142VariantBSignupRequest"] = "ACQ142VariantBSignupRequest";
  LoadingKey["ACQ142LoginAfterSignup"] = "ACQ142LoginAfterSignup";
  LoadingKey["ACQ142LoginAfterSignupMS"] = "ACQ142LoginAfterSignupMS";
  LoadingKey["ACQ143SignupRequest"] = "ACQ143SignupRequest";
  LoadingKey["ACQ143PortalCreated"] = "ACQ143PortalCreated";
})(LoadingKey || (LoadingKey = {}));